import { render } from "./ExcelDownload_Dept.vue?vue&type=template&id=d24fb4ae"
import script from "./ExcelDownload_Dept.vue?vue&type=script&lang=js"
export * from "./ExcelDownload_Dept.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/dongan_teens2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__